// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nspan.boxUnit {\n    margin: 0 4px;\n    border-radius: 5px;\n    box-shadow: 0 0 10px hsl(214,92%,60%);\n}", "",{"version":3,"sources":["webpack://src/css/JoditDocumentBuilder.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,kBAAkB;IAClB,qCAAqC;AACzC","sourcesContent":["\nspan.boxUnit {\n    margin: 0 4px;\n    border-radius: 5px;\n    box-shadow: 0 0 10px hsl(214,92%,60%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
